import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamini/h5/');
const App: React.FunctionComponent = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_mini_new');

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic
                            name={['DELTAMINI_M1.webp', 'DELTAMINI_M1.png']}
                            alt={t('second_ac_output')}
                            aria-label={t('second_ac_output')}
                        />
                        <div>
                            {t('second_ac_output_value')}
                            <br />
                            {t('second_ac_output')}
                        </div>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic
                            name={['DELTAMINI_M2.webp', 'DELTAMINI_M2.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_lightweight_value')}</span>
                        <span className="text">{t('second_lightweight')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic
                            name={['DELTAMINI_M3.webp', 'DELTAMINI_M3.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_fast_charging')}</span>
                        <span className="text">{t('second_fast_charging_value')}</span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic
                            name={['DELTAMINI_M4.webp', 'DELTAMINI_M4.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_easy_control')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic
                            name={['DELTAMINI_M5.webp', 'DELTAMINI_M5.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_capacity_value')}</span>
                        <span className="text">{t('second_capacity')}</span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic
                            name={['DELTAMINI_M6.webp', 'DELTAMINI_M6.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_solar_input_value')}</span>
                        <span className="text">{t('second_solar_input')}</span>
                    </div>
                    <div className="view-item view-item-7">
                        <EFPic
                            name={['DELTAMINI_M7.webp', 'DELTAMINI_M7.png']}
                            alt={t('second_ac_output_value')}
                            aria-label={t('second_ac_output_value')}
                        />
                        <span className="text">{t('second_safe_use_with')}</span>
                        <span className="text">{t('second_safe_use_with_value')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
